import React, { useState } from 'react';
import { Card, Typography, Collapse, Divider, Row, Col, Empty, Popover } from "antd";
import moment from 'moment';
import FeatherIcon from 'feather-icons-react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Heading from '../../../components/heading/heading';
import { ProductIcon, ServiceIcon, StaffIcon } from '../../../components/Icons/Icons';
import CustomHtmlParser from '../Email/CustomHtmlParser'
import ServicePopup from '../Popup/ServicePopup'
import AugRolePopup from '../Popup/AugRolePopup'
import ProductPage from '../Administration/AddProduct'

const { Title, Text } = Typography;
const { Panel } = Collapse;

const LeadTable = ({ displayData, currencySettings }) => {
    const [augRole, setAugRole] = useState(false)
    const [drawerOpen, setDrawerOpen] = useState(false)
    const [serviceLine, setServiceLine] = useState(false)
    const [drawerId, setDrawerId] = useState()
    const [typeOfAction, setTypeOfAction] = useState()
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const Role = localData.role
    const profile = ProfileData
    const isAllEmpty = displayData &&
        displayData.products.length === 0 &&
        displayData.service.length === 0 &&
        displayData.staffRoles.length === 0;

    if (!displayData) return null; // handle null or undefined case
    const [openPage1, setOpenPage1] = useState(Array(displayData.products?.length).fill(false));
    const [openPage2, setOpenPage2] = useState(Array(displayData.service?.length).fill(false));
    const [openPage3, setOpenPage3] = useState(Array(displayData.staffRoles?.length).fill(false));
    const handleNavigation = (type, value) => {
        setServiceLine(!serviceLine)
        setDrawerId(value)
        setTypeOfAction(type)
    }
    const handleNavigation2 = (type, value) => {
        setAugRole(!augRole)
        setTypeOfAction(type)
        setDrawerId(value)
    }
    const OpenProduct = (type, id) => {
        setDrawerOpen(!drawerOpen)
        setTypeOfAction(type)
        setDrawerId(id)
    }
    const handleOpenPageChange1 = (index) => {
        const newPopoverOpenStates = [...openPage1];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpenPage1(newPopoverOpenStates);
    };
    const handleOpenPageChange2 = (index) => {
        const newPopoverOpenStates = [...openPage2];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpenPage2(newPopoverOpenStates);
    };
    const handleOpenPageChange3 = (index) => {
        const newPopoverOpenStates = [...openPage3];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpenPage3(newPopoverOpenStates);
    };
    return (
        <>
            {isAllEmpty ? (
                <div style={{ padding: "10%" }}>
                    <Empty />
                </div>
            ) : (
                <>
                    {displayData.products?.length > 0 &&
                        <div style={{ marginBottom: 40 }}>
                            <div style={{ marginBottom: 20 }}>
                                <Heading as="h5" >Products</Heading>
                            </div>
                            {displayData.products.map((item, index) => (
                                <div key={index} style={{ marginBottom: 15 }}>
                                    <Card className="DetailsTabCard">
                                        <Collapse bordered={false} className="DetailsTabCollapse">
                                            <Panel
                                                header={
                                                    <div style={{ display: "flex", alignItems: "center", minWidth: 0, width: "100%", flex: "1 1 0%", gap: 5 }}>
                                                        <span style={{ flexShrink: 0, display: "flex" }}><ProductIcon height={16} width={16} /></span>
                                                        <Text strong style={{
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            minWidth: 0,
                                                            flex: "0 1 auto",
                                                        }} title={`${item.product_name} (${item.product_code})`}>
                                                            {item.product_name} ({item.product_code})
                                                        </Text>
                                                    </div>
                                                }
                                                key="1"
                                                extra={<div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0, whiteSpace: "nowrap" }}>
                                                    {Role !== "Basic User" &&
                                                        <Popover
                                                            placement="bottom"
                                                            content={
                                                                <div >
                                                                    <div className="text_icon newHover-class"
                                                                        role="button"
                                                                        tabIndex={0} title='View Details'
                                                                        onClick={() => {
                                                                            OpenProduct("Update", item.deal_product_id)
                                                                            handleOpenPageChange1(index)
                                                                        }}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                OpenProduct("Update", item.deal_product_id)
                                                                                handleOpenPageChange1(index)
                                                                            }
                                                                        }}
                                                                        aria-label='view'>
                                                                        <FeatherIcon icon="eye" size={16} style={{ marginRight: 5 }} /> View Details
                                                                    </div>
                                                                </div>
                                                            }
                                                            trigger="hover"
                                                            open={openPage1[index]}
                                                            onOpenChange={() => handleOpenPageChange1(index)}
                                                        >
                                                            <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                                                        </Popover>}
                                                </div>}
                                            >
                                                <Divider style={{ margin: 0 }} />
                                                <div style={{ marginTop: 10 }}>
                                                    <Text type="secondary">{item.description && item.description !== "" ? <CustomHtmlParser html={item.description} key={index} page="Previewss" /> : "Product Description"}</Text>
                                                </div>
                                                <Divider style={{ margin: "10px 0" }} />
                                                <Row gutter={30}>
                                                    <Col span={12} style={{ borderRight: "1px solid #dddddd" }}>
                                                        <Text type="secondary" className='RightSide-Lable'>Category</Text>
                                                        <br />
                                                        <Text>{item.product_category}
                                                        </Text>
                                                    </Col>
                                                    <Col span={12} style={{ borderRight: "1px solid #dddddd" }}>
                                                        <Text type="secondary" className='RightSide-Lable'>Price per Unit</Text>
                                                        <br />
                                                        <Text>{currencySettings?.symbol} {item?.product_license_selling_price_unitMonth?.toLocaleString()}
                                                        </Text>
                                                    </Col>
                                                </Row>
                                                <Divider style={{ margin: "10px 0" }} />
                                                <Row gutter={30}>
                                                    <Col span={8} style={{ borderRight: "1px solid #dddddd" }}>
                                                        <Text type="secondary" className='RightSide-Lable'>No. of Units</Text>
                                                        <br />
                                                        <Text>{item.number_of_units}
                                                        </Text>
                                                    </Col>
                                                    <Col span={8} style={{ borderRight: "1px solid #dddddd" }}>
                                                        <Text type="secondary" className='RightSide-Lable'>License Duration</Text>
                                                        <br />
                                                        <Text>{item.license_duration}
                                                        </Text>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Text type="secondary" className='RightSide-Lable'>Total</Text>
                                                        <br />
                                                        <Text>{currencySettings?.symbol} {item?.total?.toLocaleString()}
                                                        </Text>
                                                    </Col>
                                                </Row>
                                            </Panel>
                                        </Collapse>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    }
                    {displayData.service?.length > 0 &&
                        <div style={{ marginBottom: 40 }}>
                            <div style={{ marginBottom: 20 }}>
                                <Heading as="h5">Services</Heading>
                            </div>
                            {displayData.service.map((item, index) => (
                                <div key={index} style={{ marginBottom: 15 }}>
                                    <Card className="DetailsTabCard">
                                        <Collapse bordered={false} className="DetailsTabCollapse">
                                            <Panel
                                                header={
                                                    <div style={{ display: "flex", alignItems: "center", minWidth: 0, width: "100%", flex: "1 1 0%", gap: 5 }}>
                                                        <span style={{ flexShrink: 0, display: "flex" }}><ServiceIcon Height={16} width={16} /></span>
                                                        <Text strong style={{
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            minWidth: 0,
                                                            flex: "0 1 auto",
                                                        }} title={item.service_name}>
                                                            {item.service_name}
                                                        </Text>
                                                    </div>
                                                }
                                                key="1"
                                                extra={<div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0, whiteSpace: "nowrap" }}>
                                                    {Role !== "Basic User" &&
                                                        <Popover
                                                            placement="bottom"
                                                            content={
                                                                <div >
                                                                    <div className="text_icon newHover-class"
                                                                        role="button"
                                                                        tabIndex={0} title='View Details'
                                                                        onClick={() => {
                                                                            handleNavigation("Update", item.service_line_id)
                                                                            handleOpenPageChange2(index)
                                                                        }}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                handleNavigation("Update", item.service_line_id)
                                                                                handleOpenPageChange2(index)
                                                                            }
                                                                        }}
                                                                        aria-label='view'>
                                                                        <FeatherIcon icon="eye" size={16} style={{ marginRight: 5 }} /> View Details
                                                                    </div>
                                                                </div>
                                                            }
                                                            trigger="hover"
                                                            open={openPage2[index]}
                                                            onOpenChange={() => handleOpenPageChange2(index)}
                                                        >
                                                            <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                                                        </Popover>}
                                                </div>}
                                            >
                                                <Divider style={{ margin: 0 }} />
                                                <div style={{ marginTop: 10 }}>
                                                    <Text type="secondary">{item.description && item.description !== "" ? item.description : "Service description"}</Text>
                                                </div>
                                                <Divider style={{ margin: "10px 0" }} />
                                                <Row gutter={30}>
                                                    <Col span={12} style={{ borderRight: "1px solid #dddddd" }}>
                                                        <Text type="secondary" className='RightSide-Lable'>Parent Service Line</Text>
                                                        <br />
                                                        <Text>
                                                            {item.parent_service_line}
                                                        </Text>
                                                    </Col>
                                                    <Col span={12}>
                                                        <Text type="secondary" className='RightSide-Lable'>Total</Text>
                                                        <br />
                                                        <Text>{currencySettings?.symbol} {item?.service_line_cost?.toLocaleString()}</Text>
                                                    </Col>
                                                </Row>
                                            </Panel>
                                        </Collapse>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    }
                    {displayData.staffRoles?.length > 0 &&
                        <div style={{ marginBottom: 40 }}>
                            <div style={{ marginBottom: 20 }}>
                                <Heading as="h5" >Staff Roles</Heading>
                            </div>
                            {displayData.staffRoles.map((item, index) => (
                                <div key={index} style={{ marginBottom: 15 }}>
                                    <Card className="DetailsTabCard">
                                        <Collapse bordered={false} className="DetailsTabCollapse">
                                            <Panel
                                                header={
                                                    <div style={{ display: "flex", alignItems: "center", minWidth: 0, width: "100%", flex: "1 1 0%", gap: 5 }}>
                                                        <span style={{ flexShrink: 0, display: "flex" }}><StaffIcon Height={16} width={16} /></span>
                                                        <Text strong style={{
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            minWidth: 0,
                                                            flex: "0 1 auto",
                                                        }} title={`${item.roleName} (${item.country})`}>{item.roleName} ({item.country})</Text>
                                                    </div>
                                                }
                                                key="1"
                                                extra={<div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0, whiteSpace: "nowrap" }}>
                                                    {Role !== "Basic User" &&
                                                        <Popover
                                                            placement="bottom"
                                                            content={
                                                                <div >
                                                                    <div className="text_icon newHover-class"
                                                                        role="button"
                                                                        tabIndex={0} title='View Details'
                                                                        onClick={() => {
                                                                            handleNavigation("Update", item.add_staff_role_id);
                                                                            handleOpenPageChange3(index)
                                                                        }}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                handleNavigation("Update", item.add_staff_role_id);
                                                                                handleOpenPageChange3(index)
                                                                            }
                                                                        }}
                                                                        aria-label='view'>
                                                                        <FeatherIcon icon="eye" size={16} style={{ marginRight: 5 }} /> View Details
                                                                    </div>
                                                                </div>
                                                            }
                                                            trigger="hover"
                                                            open={openPage3[index]}
                                                            onOpenChange={() => handleOpenPageChange3(index)}
                                                        >
                                                            <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                                                        </Popover>}
                                                </div>}
                                            >
                                                <Divider style={{ margin: 0 }} />
                                                <Title level={5} style={{ marginTop: 10 }}>
                                                    Per day Rate ({currencySettings?.currency}) : {currencySettings?.symbol} {item.role_per_day_rate?.toLocaleString()}
                                                </Title>
                                                <Divider style={{ margin: "10px 0" }} />
                                                <Row gutter={30}>
                                                    <Col span={8} style={{ borderRight: "1px solid #dddddd" }}>
                                                        <Text type="secondary" className='RightSide-Lable'>Start Date</Text>
                                                        <br />
                                                        <Text>
                                                            {item.start_date && profile.dateFormate
                                                                ? moment(item.start_date).format(profile.dateFormate)
                                                                : moment(item.start_date).format("YYYY-MM-DD")}
                                                        </Text>
                                                    </Col>
                                                    <Col span={8} style={{ borderRight: "1px solid #dddddd" }}>
                                                        <Text type="secondary" className='RightSide-Lable'>End Date</Text>
                                                        <br />
                                                        <Text>
                                                            {item.end_date && profile.dateFormate
                                                                ? moment(item.end_date).format(profile.dateFormate)
                                                                : moment(item.end_date).format("YYYY-MM-DD")}
                                                        </Text>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Text type="secondary" className='RightSide-Lable'>Total</Text>
                                                        <br />
                                                        <Text> {currencySettings?.symbol} {item.total_value?.toLocaleString()}</Text>
                                                    </Col>
                                                </Row>
                                            </Panel>
                                        </Collapse>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    }
                </>
            )
            }
            <ProductPage drawerOpen={drawerOpen} OpenProduct={OpenProduct} drawerType={typeOfAction} drawerId={drawerId} typePage="Details" />
            <ServicePopup serviceLine={serviceLine} handleNavigation={handleNavigation} typeOfAction={typeOfAction} serviceLineId={drawerId} typePage="Details" />
            <AugRolePopup augRole={augRole} handleNavigation={handleNavigation2} typeOfAction={typeOfAction} jobRoleId={drawerId} typePage="Details" />
        </>
    )
}
LeadTable.propTypes = {
    currencySettings: PropTypes.array.isRequired,
    displayData: PropTypes.object.isRequired,
};
export default React.memo(LeadTable)